import { Group, Stack, TextInput } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';

export type Address = {
  id?: string;
  address1: string;
  address2: string;
  address3: string;
  city: string;
  postalCode: string;
  code1: string;
  code2: string;
  floor: string;
  elevator: string;
};

export const AddressFields = ({
  prefix,
  form,
  required = false,
  disabled = false,
  disabledFields = [],
  defaultAddress,
}: {
  prefix: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  form: UseFormReturnType<any>;
  required?: boolean;
  disabled?: boolean;
  disabledFields?: string[];
  defaultAddress?: Address;
}) => {
  const getInputProps = (path: string) => {
    if (disabled) {
      return {
        value: defaultAddress?.[path as keyof Address],
      };
    }
    return form.getInputProps(`${prefix}.${path}`);
  };

  return (
    <Stack gap="md">
      <TextInput
        label="Nom/Raison sociale"
        {...getInputProps('address1')}
        required={required}
        disabled={disabled || disabledFields.includes('address1')}
      />
      <TextInput
        label="Numéro et nom de rue"
        {...getInputProps('address2')}
        disabled={disabled || disabledFields.includes('address2')}
      />
      <TextInput
        label="Complément d'adresse"
        {...getInputProps('address3')}
        disabled={disabled || disabledFields.includes('address3')}
      />

      <Group grow>
        <TextInput
          label="Code postal"
          {...getInputProps('postalCode')}
          required={required}
          disabled={disabled || disabledFields.includes('postalCode')}
        />
        <TextInput
          label="Ville"
          {...getInputProps('city')}
          required={required}
          disabled={disabled || disabledFields.includes('city')}
        />
      </Group>

      <Group grow>
        <TextInput
          label="Code 1"
          {...getInputProps('code1')}
          disabled={disabled || disabledFields.includes('code1')}
        />
        <TextInput
          label="Code 2"
          {...getInputProps('code2')}
          disabled={disabled || disabledFields.includes('code2')}
        />
      </Group>

      <Group grow>
        <TextInput
          label="Étage"
          {...getInputProps('floor')}
          disabled={disabled || disabledFields.includes('floor')}
        />
        <TextInput
          label="Ascenseur"
          {...getInputProps('elevator')}
          disabled={disabled || disabledFields.includes('elevator')}
        />
      </Group>
    </Stack>
  );
};
